import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const leasePlan = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      "Waehlen Sie Ihre Marke.": "Wählen Sie Ihre Marke",
      "Waehlen Sie Ihren Wunschort.": "Wählen Sie Ihren Wunschort",
      hero: {
        title: "Willkommen bei der Werkstatt-Buchung von {{organization}}",
        subtitle: null,
      },
      welcomeModal: {
        title: "Sie verlassen nun die Seite von {{organization}}",
        text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt {{organization}} nicht verantwortlich ist und die Datenschutzbestimmungen von {{organization}} keine Anwendung finden.",
      },
      hint: {
        text: "Alle gezeigten Werkstätten sind offizielle Ayvens Partner.",
        appointmentText: `Weitere Partner stehen zur telefonischen Terminvereinbarung in der <a class="text-white" target="_blank" href='https://www.ayvens.de/werkstattpartnersuche'>Umkreissuche</a> bereit.`,
      },
      benefits: {
        title: "Ihre Vorteile",
        "bullet-point-1": "Freie Termine direkt online buchen oder telefonisch vereinbaren",
        "bullet-point-2":
          "Die besten Werkstattpartner auf einem Blick – bewertet nach den Qualitätsstandards von {{organization}}",
        "bullet-point-3": "",
        feedbackTitle: "Feedback",
      },
      booking: {
        "please-choose-services": "Benötigte Services wählen",
        "appointment-hint":
          "Bitte beachten Sie bei Ihrer Werkstattauswahl, dass Garantiearbeiten und Rückrufaktionen nur bei Herstellerwerkstätten durchgeführt werden können.",
        moreInformation: {
          "bullet-point-3":
            "Die Werkstatt informiert Sie telefonisch, sobald Sie Ihr Auto abholen können.",
          "bullet-point-5": "Es ist die Ayvens Tank- oder Servicekarte vorzulegen.",
          "bullet-point-6": "Es ist der Reparaturauftrag auszufüllen und abzugeben.",
        },
      },
      garageList: {
        filters: {
          premiumServices: {
            "additional-cost-info": "",
          },
        },
        emptyState: {
          headline: "Bitte prüfen Sie Ihre Suchkriterien.",
          description:
            "Wir konnten keine Werkstätten im Ayvens Partnernetzwerk für Ihre Suchkriterien finden. Sie können folgendes machen:",
          "bullet-point-1": "Suchradius erweitern",
          "bullet-point-2": "Filter ändern",
          radiusHint:
            "Wenn Sie im Umkreis von mindestens 30 km keine Partnerwerkstatt finden, können Sie jede nächstgelegene autorisierte Vertragswerkstatt nutzen.",
        },
      },
      hotline: {
        "hotline-headline": "",
        "hotline-phone-link": "tel:+4921191358221",
        "hotline-phone": "+49 211 9135 8221",
        "hotline-availability": "",
        "hotline-via-email": "",
        "hotline-via-email-email": "",
      },
      layout: {
        backText: "Zurück zu ayvens.com",
      },
      homeStep: {
        pleaseUseDifferentSearch: `Wir konnten für Ihre Suchkriterien aktuell keine Werkstätten mit Onlineterminvereinbarung finden.
                                                Bitte nutzen Sie die <a target="_blank" href='https://www.ayvens.de/werkstattpartnersuche'>Umkreissuche für Werkstattpartner</a> auf der Ayvens Website.`,
      },
      linkToHome: "https://werkstatt.repareo.de/partner/ayvens",
      contact: {
        reachability: "8 - 18 Uhr | Montag - Donnerstag\n8 - 17 Uhr | Freitag",
        phone: {
          link: "tel:004989244182013",
          title: "+49 89 244 182 013",
        },
      },
    },
  },
};
